/**
 * Author(s) : Dhanush Kumaar
 * Purpose : This is the Splash Sreen Page for Logo Animations.
 */

import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoAnimation from '../../components/logoAnimation/LogoAnimation';
import { HOME_ROUTE } from '../../constants';

const SplashScreen = (props) => {
  const navigate = useNavigate();
  const { theme } = props;

  useEffect(() => {
    setTimeout(() => {
      navigate(HOME_ROUTE);
    }, 6240);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2 }}
      exit={{ opacity: 0 }}>
      <LogoAnimation isScreenSaver={false} theme={theme}></LogoAnimation>
    </motion.div>
  );
};

SplashScreen.propTypes = {
  theme: PropTypes.string,
};

export default SplashScreen;
